/**
 * The deep link: /tickets/:id.
 *
 * The inbox and this page render the SAME component — `TicketPane` — so the
 * embedded reading pane and the standalone workspace cannot drift apart. This
 * wrapper only adds the way back.
 */

import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { TicketPane } from '../components/ticket/TicketPane';

export function TicketWorkspace() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0 border-b border-line bg-surface px-4 py-2">
        <Link
          to="/inbox"
          className="inline-flex items-center gap-1.5 text-sm text-ink-500 hover:text-ink-900"
        >
          <ArrowLeft size={14} strokeWidth={1.75} aria-hidden />
          Inbox
        </Link>
      </div>
      <div className="min-h-0 flex-1">
        <TicketPane ticketId={id} />
      </div>
    </div>
  );
}
